import { TakeAgain } from '@/components/Consultation/steps/Answer/TakeAgain'
import { WarningIcon } from '@/components/icons/WarningIcon'
import { getSlugTranslation } from '@/locale/utils'

export const ReportError = () => (
  <div className="flex flex-1 flex-col items-center justify-between gap-4 overflow-y-auto p-4" data-testid="report-error">
    <section className="drop-shadow-chat-bubble flex w-full max-w-md flex-col items-center gap-4 rounded-2xl bg-white px-6 py-9 text-center">
      <WarningIcon className="h-8 w-8 text-orange-500" />
      <div className="flex flex-col gap-2">
        <h2 className="font-bold">{getSlugTranslation('general.consultation.reportError.title')}</h2>
        <p className="text-gray-text">{getSlugTranslation('general.consultation.reportError.description')}</p>
      </div>
    </section>

    <TakeAgain dataTestId="report-error-close" />
  </div>
)
